export const ADMINISTRATORS = ['nt', 'link'] as const

export type Administrator = (typeof ADMINISTRATORS)[number]

export const ADMINISTRATOR_LABELS: Record<Administrator, string> = {
  nt: 'NT',
  link: 'LINK',
}

export const ADMINISTRATOR_OPTIONS = ADMINISTRATORS.map((t) => ({
  label: ADMINISTRATOR_LABELS[t],
  value: t,
})).sort()
